export default __webpack_public_path__ + "static/media/outcome-of-board-meeting.1de0181a.pdf";